import Link from "next/link";
import { TbAlertSquareRoundedFilled } from "react-icons/tb";
const Hero = () => {
  return (
    <div className="flex h-full w-full select-none flex-col items-center justify-around gap-2 p-12 text-center">
      <div className="flex">
        <h2 className="text-4xl font-extrabold leading-10 tracking-tight text-blue-600 sm:text-5xl sm:leading-none md:text-6xl">
          Welcome to
        </h2>
        <h2 className="text-4xl font-extrabold leading-10 tracking-tight text-white sm:text-5xl sm:leading-none md:text-6xl">
          AI<span className="text-blue-600">PX</span>
        </h2>
        <TbAlertSquareRoundedFilled className="text-4xl font-extrabold leading-10 tracking-tight text-white sm:text-5xl sm:leading-none md:text-6xl" />
      </div>
    </div>
  );
};

export default Hero;
